import ItemActions from './ItemActions'

module.exports = ItemActions.create( { 
  parentName : 'system', 
  itemsName : 'contacts', 
  actionTypeBase : 'CONTACT', 
  parentIdKey : 'systemId', 
  humanItemName : 'Contact' 
} )

/*
import NotifyActions from './NotifyActions'

const GET_CONTACTS = "GET_CONTACTS"
const ADD_CONTACT = "ADD_CONTACT"
const REMOVE_CONTACT = "REMOVE_CONTACT"
const UPDATE_CONTACT = "UPDATE_CONTACT"

export function getContacts( systemId ) {
  return function( dispatch, getState, api ) {
    api.getSystem( systemId )
      .then( ( system ) => { 
        api.getContacts( systemId )
          .then( ( data ) => {
            dispatch( { type : GET_CONTACTS, system, contacts : data.items })
          })
          .catch( ( ex ) => {
            dispatch( NotifyActions.requestError( 'Unable to get contacts', ex))
          })
      })
      .catch( ( ex ) => {
        dispatch( NotifyActions.requestError( 'Unable to get system for contacts', ex))
      })
  }
}

export function addContact( systemId, contact ) {
  return function( dispatch, getState, api ) {
    api.addContact( systemId, contact )
      .then( ( data ) => {
        dispatch( { type : ADD_CONTACT, systemId : systemId, contact : data })
      })
      .catch( ( ex ) => {
        dispatch( NotifyActions.requestError( 'Unable to add contact', ex))
      })
  }
}

export function removeContact( systemId, contactId ) {
  return function( dispatch, getState, api ) {
    api.removeContact( systemId, contactId )
      .then( ( data ) => {
        dispatch( { type : REMOVE_CONTACT, systemId, contactId })
      })
      .catch( ( ex ) => {
        dispatch( NotifyActions.requestError( 'Unable to remove contact', ex))
      })
  }
}

export function updateContact( contact, patchOps ) {
  return function( dispatch, getState, api ) {

    return api.updateContact( contact.systemId, contact.id, patchOps )
      .then( data => {
        dispatch( { type : UPDATE_CONTACT, contact : data } )
      })
      .catch( ex => {
        dispatch( NotifyActions.requestError( 'Unable to update contact', ex))
      })
  };
}

module.exports = { 
  GET_CONTACTS, ADD_CONTACT, REMOVE_CONTACT, UPDATE_CONTACT,

  getContacts, addContact, removeContact, updateContact
}
*/
